import { render, staticRenderFns } from "./AlunosGratuidadeOld.vue?vue&type=template&id=72de1533&scoped=true"
import script from "./AlunosGratuidadeOld.vue?vue&type=script&lang=js"
export * from "./AlunosGratuidadeOld.vue?vue&type=script&lang=js"
import style0 from "./AlunosGratuidadeOld.vue?vue&type=style&index=0&id=72de1533&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72de1533",
  null
  
)

export default component.exports